/* ==================================================================
   GB — "Mega Menu with Image" hover swap (header menu_type_desktop =
   'mega-image'; loaded only in that mode by header.liquid).
   Each mega panel renders one stock collection card per unique
   collection linked in it (header-mega-menu.liquid); the first —
   the top-left heading's collection — is active on load. Hovering
   or keyboard-focusing any collection link (level-2 heading OR
   level-3 sub-link, marked data-gb-mega-card) activates that
   collection's card; the swap is a class toggle, so images lazy-load
   on first show and are instant after. Closing the menu resets to
   the first card. Links without the attribute (pages, custom URLs)
   swap nothing. Dawn's header-menu / details behavior and the GB
   hover-open logic (header-hover-menu.js) are untouched.
   ================================================================== */
(function () {
  function bindPanel(wrap) {
    if (wrap.dataset.gbMegaImageBound === 'true') return;
    wrap.dataset.gbMegaImageBound = 'true';

    var cards = Array.prototype.slice.call(
      wrap.querySelectorAll('[data-gb-mega-card-for]')
    );
    if (cards.length === 0) return;

    var byHandle = {};
    cards.forEach(function (card) {
      byHandle[card.getAttribute('data-gb-mega-card-for')] = card;
    });

    function activate(handle) {
      var target = byHandle[handle];
      if (!target || target.classList.contains('is-active')) return;
      cards.forEach(function (card) {
        card.classList.toggle('is-active', card === target);
      });
    }

    function reset() {
      cards.forEach(function (card, index) {
        card.classList.toggle('is-active', index === 0);
      });
    }

    wrap.querySelectorAll('[data-gb-mega-card]').forEach(function (link) {
      var handle = link.getAttribute('data-gb-mega-card');
      link.addEventListener('mouseenter', function () {
        activate(handle);
      });
      // Keyboard parity: tabbing through links tracks the card too.
      link.addEventListener('focus', function () {
        activate(handle);
      });
    });

    // Back to the top-left heading's card whenever the menu closes.
    var details = wrap.closest('details');
    if (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) reset();
      });
    }
  }

  function init() {
    document.querySelectorAll('.mega-menu__with-image').forEach(bindPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: rebind after the header section re-renders.
  document.addEventListener('shopify:section:load', init);
})();
